/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Autocomplete reducers
 */

import { payloadReducer } from '@zcode/reducers'
import type { Autocomplete } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  CLEAR_FETCHING_KEY,
  HIDE_MOBILE_AUTOCOMPLETE,
  SET_FETCHING_KEY,
  SET_IS_CURRENT_LOCATION_LOADING,
  SET_IS_FETCHING,
  SET_MOBILE_ORIGIN,
  SHOW_MOBILE_AUTOCOMPLETE,
} from '../constants'

type Actions = ExtractActions<Values<typeof actions>>

const autocompleteReducer = combineReducers<Autocomplete, Actions>({
  showMobileAutocomplete: handleActions(
    { [SHOW_MOBILE_AUTOCOMPLETE]: () => true, [HIDE_MOBILE_AUTOCOMPLETE]: () => false },
    false
  ),
  isCurrentLocationLoading: handleAction<
    Autocomplete['isCurrentLocationLoading'],
    Actions,
    typeof SET_IS_CURRENT_LOCATION_LOADING
  >(SET_IS_CURRENT_LOCATION_LOADING, payloadReducer, false),
  isFetching: handleAction<Autocomplete['isFetching'], Actions, typeof SET_IS_FETCHING>(
    SET_IS_FETCHING,
    payloadReducer,
    false
  ),
  // TODO: Move fetchingKey to meta
  fetchingKey: handleActions(
    {
      [CLEAR_FETCHING_KEY]: () => '',
      [SET_FETCHING_KEY]: payloadReducer,
    },
    ''
  ),
  mobileOrigin: handleAction<Autocomplete['mobileOrigin'], Actions, typeof SET_MOBILE_ORIGIN>(
    SET_MOBILE_ORIGIN,
    payloadReducer,
    null
  ),
})

export default autocompleteReducer
